import React, { useEffect, useState } from 'react'
import '../styles/program.scss'
//import DatePickerContainer from '../datepicker/DatePickerContainer'
//import CONSTANTS from '../movielist-constants'
//import xml2js from '../../lib/xml-to-js';
//import DayPicker from 'react-day-picker';
import moment from 'moment'
//import downarrow from './images/down-arrow-backup-2-svgrepo-com (1).svg'
import check from "../images/check-mark.svg";
//import checkIcon from "./images/check-mark.svg";


export default function Dates({ datearr, selectedDate, setSelectedDate }) {
    const [isOpen, setIsOpen] = useState(false);

    // ----------SELECTED DATE CALCULATIONS---------------------
   
    function handleDayClick(days) {

      
        setIsOpen((current) => !current);

       // console.log(days, 'days')
      //  console.log(selectedDate, 'selectéd date')
        if (days == selectedDate) {
            setSelectedDate()
        }
        else setSelectedDate(days)
    }
  //  console.log(selectedDate, 'selected date')

    function handleRegionArrrow() {
        setIsOpen((current) => !current);
    }


   
    return (
        
        <div className=" dropdownContainer">
                   
            <div className="chooseRegion" style={{
                borderBottomLeftRadius: isOpen ? '0px' : '8px',
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
                borderBottomRightRadius: isOpen ? '0px' : '8px',
                zIndex: isOpen ? 99 : 1
            }}>
                            <div
                                style={{
                                    position: "relative",
                                   // padding: "5px 8px",
                                    boxSizing: "border-box",
                         //   height: "31px",
                          //  borderBottom: isOpen ? '1px solid grey' : ''
                                }}
                    >
                        <p style={{ marginTop: '10px', fontSize: '18px', paddingLeft: '16px', letterSpacing: '0.54px', paddingTop: '10px', }}> {selectedDate ? selectedDate : ' Dato '} </p>
                        
                             
                        <button className='chooseBtn'
                            onClick={handleRegionArrrow} 
                                    
                                >
                                    <p /*className={isOpen ? "rotated" : ""}*/>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                    <path d="M1.5 1L10 10L18.5 1" stroke="white" stroke-width="2" stroke-linecap="round" />
                                </svg>
                                    </p>
                                </button>
                            </div>
                            {isOpen && (
                        <div className='scroll'
                            style={{
                                     
                                backgroundColor: "#2B3040",
                                        maxHeight: "270px",
                                        overflowX: 'auto',
                                        position: 'relative',
                                        zIndex: 100,
                                        width: '100%',top:'-1px'
                                    }}
                        >
                            {datearr.sort(function (a, b) {
                                let curr = a.split('-').reverse().join();
                                let prev = b.split('-').reverse().join();
                                return curr < prev ? -1 : (curr > prev ? 1 : 0);
                            }).map((date,index) => (
                                  <div key={index} style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    height: "44px",
                                    padding: "10px", borderRadius:'6px',
                                  //  borderRight: '1px solid #757575',
                                    width: '95%',
                                    backgroundColor: datearr.length && selectedDate == date ? '#3E455C' : ''
                                  }} onClick={() => handleDayClick(date)}>
                                    <p style={{ margin: 0, fontSize: '18px', fontWeight: 500, letterSpacing: '0.54px' }}>{date}</p>
                                   
                                        {selectedDate == date ?

                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                            <path d="M7 11L11 16L17.5 7" stroke="white" stroke-width="2" stroke-linecap="round" />
                                        </svg>
                                        :
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect x="1" y="1" width="22" height="22" rx="3" stroke="white" stroke-width="2" />
                                        </svg>}
                                   
                                </div>
                             )) }
                            
                           
                                </div>
                            )}
                        </div>
                    
                    
                </div>
               

           
        )
}